import { ActionType } from '../../types/action';

// Company permissions
const readCompanyPermission = {
  resource: 'thrift-company',
  action: ActionType.READ,
};

const updateCompanyPermission = {
  resource: 'thrift-company',
  action: ActionType.UPDATE,
};

const deleteCompanyPermission = {
  resource: 'thrift-company',
  action: ActionType.DELETE,
};

const readCompaniesPermission = {
  resource: 'thrift-companies',
  action: ActionType.READ,
};

const createCompanyPermission = {
  resource: 'thrift-companies',
  action: ActionType.CREATE,
};

const updateCompaniesPermission = {
  resource: 'thrift-companies',
  action: ActionType.UPDATE,
};

// Company Document permissions
const readCompanyDocumentsPermission = {
  resource: 'thrift-company-documents',
  action: ActionType.READ,
};

const createCompanyDocumentPermission = {
  resource: 'thrift-company-documents',
  action: ActionType.CREATE,
};

const readCompanyDocumentPermission = {
  resource: 'thrift-company-document',
  action: ActionType.READ,
};

const updateCompanyDocumentPermission = {
  resource: 'thrift-company-document',
  action: ActionType.UPDATE,
};

const deleteCompanyDocumentPermission = {
  resource: 'thrift-company-document',
  action: ActionType.DELETE,
};

export const Company = {
  read: readCompanyPermission,
  update: updateCompanyPermission,
  delete: deleteCompanyPermission,
  list: readCompaniesPermission,
  create: createCompanyPermission,
  updateList: updateCompaniesPermission,
  readDocuments: readCompanyDocumentsPermission,
  createDocument: createCompanyDocumentPermission,
  readDocument: readCompanyDocumentPermission,
  updateDocument: updateCompanyDocumentPermission,
  deleteDocument: deleteCompanyDocumentPermission,
};
